import { Controller } from "@hotwired/stimulus";

const CONNECTED = "connected";
const UNCONNECTED = "unconnected";

export default class extends Controller {
  static targets = [
    "additionalInformation",
    "connectionChoice",
    "connectionChoiceExplanation",
    "connectionRadio",
    "connectionRadioUnconnected",
    "connectServiceButton",
    "image",
    "imagePlaceholder",
    "makeSelect",
    "maxBatteryCapacity",
    "maxBatteryRange",
    "modelSelect",
    "modelSelection",
  ];

  connect() {
    this.hiddenModelOptions = [];
    this.filterModelOptions();
  }

  makeChanged() {
    this.selectedModelOption.selected = false;
    this.updateImage();
    this.filterModelOptions();
    this.translateExplanation();
    this.translateConnectButton();
    this.updateUI();
  }

  filterModelOptions() {
    this.modelSelectTarget
      .querySelectorAll(`option:not([data-make='${this.selectedMake}']):not([value=''])`)
      .forEach((option) => {
        const hiddenModelOption = this.modelSelectTarget.removeChild(option);
        console.log(hiddenModelOption);
        this.hiddenModelOptions.push(hiddenModelOption);
      });

    this.hiddenModelOptions.forEach((option) => {
      if (option.dataset.make === this.selectedMake) {
        this.modelSelectTarget.appendChild(option);
      }
    });
  }

  translateConnectButton() {
    this.connectServiceButtonTarget.dispatchEvent(
      new CustomEvent(
        'i18n:translate',
        {
          detail: {
            params: { service: this.service },
          },
        }
      ),
    );
  }

  translateExplanation() {
    this.connectionChoiceExplanationTarget.dispatchEvent(
      new CustomEvent(
        'i18n:translate',
        {
          detail: {
            params: { make: this.selectedMake },
          },
        }
      ),
    );
  }

  updateUI() {
    this.modelSelectionTargets.forEach((node) => {
      node.classList.toggle("hidden", !this.showModelSelect);
    });

    this.connectionChoiceTarget.classList.toggle("hidden", !this.connectionIsSupported);
    this.connectServiceButtonTarget.classList.toggle("hidden", !this.showConnectButton);

    this.additionalInformationTargets.forEach((node) => {
      node.classList.toggle("hidden", !this.showAdditionalInformation);
    });
  }

  updateImage() {
    const { image} = this.selectedModelOption.dataset;
    const hasImage = !!image;
    this.imageTarget.classList.toggle("hidden", !hasImage);
    this.imagePlaceholderTarget.classList.toggle("hidden", hasImage);

    if (hasImage) {
      this.imageTarget.src = image;
    }
  }

  connectService() {
    const { connectServiceURL, connectConfirmation } = this;

    if (confirm(connectConfirmation)) {
      window.location = connectServiceURL;
    }
  }

  get selectedMakeOption() { return this.makeSelectTarget.selectedOptions[0]; }
  get selectedMake() { return this.selectedMakeOption.value; }
  get selectedModelOption() { return this.modelSelectTarget.selectedOptions[0]; }
  get modelIsSelected() { return this.selectedModelOption?.value !== ''; }

  get service() { return this.selectedMakeOption.dataset.service; }
  get connectServiceURL() { return this.selectedMakeOption.dataset.connectServiceUrl; }
  get connectConfirmation() { return this.selectedMakeOption.dataset.connectConfirmation; }
  get connectionIsSupported() { return !!this.connectServiceURL; }

  get connectionChoice() {
    return this.connectionRadioTargets.find((node) => node.checked)?.value;
  }

  get showModelSelect() {
    return this.selectedMakeOption && (!this.connectionIsSupported || this.connectionChoice === UNCONNECTED);
  }

  get showAdditionalInformation() {
    return this.modelIsSelected && (this.connectionChoice === UNCONNECTED || !this.connectionIsSupported);
  }

  get showConnectButton() {
    return this.connectionIsSupported && this.connectionChoice === CONNECTED;
  }
}
